import Translator from '../../classes/Translator/Translator';
const PricingLogic = () => {
  const { translator } = Translator();

  return {
    translator,
  };
};
export default PricingLogic;
